import { Component } from '@angular/core';

@Component({
  selector: 'icon-add-file',
  templateUrl: './icon-add-file.component.html',
  styleUrls: ['./icon-add-file.component.sass']
})
export class IconAddFileComponent {}
